import React from 'react';

function About() {
  return (
    <div className="container px-4 px-lg-5 mt-5">
      <h1 className="mb-4">About Us</h1>

      <p>
        Founded in 2019 by Annette Wilson, President and CEO, Ntrepid Design has been on a remarkable journey, bringing the beauty of 
        African craftsmanship to the global fashion scene. Despite challenges, including the COVID-19 pandemic, 
        we remain committed to quality, cultural expression, and customer satisfaction.
      </p>

      <p>
        Ntrepid Design is a division of Ntrepid Entities International, LTD, Ghana, West Africa. We have a manufacturing facility, storefront, and administrative office 
        strategically located in Ghana, managed by Samuel Ababio, Director of Operations. This unique positioning allows us to blend authentic African heritage 
        with contemporary fashion trends.
      </p>

      <p>
        Our designers take meticulous care in crafting each garment, ensuring every piece embodies 
        exceptional quality, vibrant artistry, and the rich cultural storytelling of Africa. 
        Our store offers unique handmade garments, accessories, home décor, and various works of art.
        We are constantly updating our inventory.
      </p>

      <h2 className="mt-5">Return Policy</h2>
      <p><strong>ALL SALES ARE FINAL</strong></p>

      <p>
        At Ntrepid Design, our team of expert designers, seamstresses, and artists make every effort 
        to ensure your custom order is perfect.
      </p>

      <p>
        If an item is incorrectly sized, we will correct or remake the clothing item. 
        We also accept returns or exchanges for products that were damaged in transit or if the incorrect item was shipped.
      </p>

      <p>
        To be eligible for a return or exchange, you must first email Ntrepid Design within 30 days of the order date 
        at  <a href="mailto:ntrepiddesign@outlook.com">ntrepiddesign@outlook.com</a>. Upon receipt of your email, we will respond promptly to ensure your replacement 
        is sent out as quickly as possible.
      </p>
    </div>
  );
}

export default About;
